import React from 'react';
import withAnalytics, { AnalyticsProps } from '../analytics';
import {
	Button as ButtonComponent,
	type ButtonProps,
} from '@nvs/leap-web-components';

export const Button = withAnalytics<AnalyticsProps & ButtonProps>(
	ButtonComponent<AnalyticsProps>
);

export default Button;
